module.exports = __webpack_public_path__ + "img/address.83889310.svg";